import axios from 'axios';
import config from '@/config';

let Endpoint = {
    init: () => {
         axios.defaults.baseURL = config.BASE_URL;
    },

    getCategories: (merchantId) => {
        return axios.get(`/payment_link/v1/${encodeURIComponent(merchantId)}/storefront/categories`)
    },

    getProducts: (merchantId, currencies, page) => {
        return axios.get(`/payment_link/v1/${encodeURIComponent(merchantId)}/storefront/products`, {
            params: { 'currencies[]': currencies, page, perPage: 12 }
        })
    },

    getFilteredProducts: (merchantId, currencies, page, category, priceOrder, maxPrice, searchQ) => {
        const params = { 'currencies[]': currencies, page, perPage: 12 };
        if (category) params.category = category;
        if (priceOrder) params.dir = priceOrder;
        if (maxPrice) { params.price_from = 1; params.price_to = maxPrice; }
        if (searchQ) params.search = searchQ;

        return axios.get(`/payment_link/v1/${encodeURIComponent(merchantId)}/storefront/products`, { params })
    },

    createOrder: (payload) => {
        return axios.post(`/payment_link/v1/orders/noLink`, payload)
    },

    getLocations: (merchantId) => {
        return axios.get(`/payment_link/v1/${encodeURIComponent(merchantId)}/storefront/locations`, {
            params: { allow_all: true }
        })
    },

    getPickupLocations: (merchantId) => {
        return axios.get(`/payment_link/v1/${encodeURIComponent(merchantId)}/storefront/pickup_locations`)
    },

    getDiscountByCode: (merchantId, code) => {
        return axios.get(`/payment_link/v1/discounts/${encodeURIComponent(code)}`)
    }

}

export default Endpoint
